import {
  ComponentPropsWithoutRef,
  createContext,
  Dispatch,
  SetStateAction,
  useCallback,
  useContext,
  useState,
} from "react";

import SavedTag from "components/saved-tag";

type Context = {
  savedTagProps: ComponentPropsWithoutRef<typeof SavedTag>;
  setSavedTagProps: Dispatch<
    SetStateAction<ComponentPropsWithoutRef<typeof SavedTag>>
  >;
};

const SavedTagContext = createContext<Context>({
  savedTagProps: { show: false },
  setSavedTagProps: () => null,
});

export const SavedTagContextProvider = ({ children }) => {
  const [savedTagProps, setSavedTagProps] = useState<Context["savedTagProps"]>({
    show: false,
  });

  const handleHide = useCallback(() => setSavedTagProps({ show: false }), []);
  return (
    <SavedTagContext.Provider
      value={{
        savedTagProps,
        setSavedTagProps,
      }}
    >
      <SavedTag {...savedTagProps} onHide={handleHide} />
      {children}
    </SavedTagContext.Provider>
  );
};

export const useSavedTag = () => useContext(SavedTagContext);
